<script>
import { BFormRating } from "bootstrap-vue";

export default {
  extends: BFormRating
};
</script>